
import React, { useState } from "react";
import { Http } from "../../../../../helpers/axois";
import "./update-widget.scss";

import { Spinner } from "../../../../../helpers/commonUi/Spinner";

interface IProps {
  setObjectUrl: (key: string, value: any) => void;
  orgId: string;
}

export const UpdateWidget: React.FC<IProps> = ({ setObjectUrl, orgId }) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);

  const handleInputChange = async (e: any) => {
    if (e.target.files.length) {
      setLoading(true);
      const file = e.target.files[0];
      setFile(file.name)
      const endpoint = `/orgs/${orgId}/store/artifacts/upload`;

      const formData = new FormData();
      formData.append("file", file);

      try {
        const res: any = await Http.post(endpoint, formData).toPromise();
        setObjectUrl('objectUrl', res.objectUrl);
        setLoading(false);
      } catch (e) {
        console.error(e);
        setLoading(false);
      }
    }
  };

  return (
    <div className="update-widget">
      <h5>Upload Application</h5>
      {loading ?
        <div className="update-widget-content"><Spinner /></div>
        : file ?
          <div className="update-widget-content">
            <div className="widget-file">
              <p>File Name: {file}</p> <button data-test-id="close" className="close-btn" onClick={() => setFile(null)} >
                X
              </button>
            </div>
          </div> : (
            <div className="update-widget-content">
              <label htmlFor="artifact-upload" className="upload-btn">
                Upload Application
              </label>
              <input
                type="file"
                id="artifact-upload"
                style={{ display: "none" }}
                onChange={handleInputChange}
                accept=".zip"
              />
            </div>
          )}
    </div>
  );
};
